<script setup lang="ts">
defineProps<{ products: Packet[] }>();
</script>

<template>
  <ul v-if="products.length" class="flex flex-col gap-l md:grid md:grid-cols-2 lg:flex lg:flex-row">
    <li
      v-for="product in products"
      :key="product.id"
      class="w-full"
    >
      <CardsRelated
        :product="toProductCard(product)"
        :tag="product.format"
      />
    </li>
  </ul>
</template>
